import React from 'react';
import { getAppStatusConfig } from '~/modules/covenants/statusConfig.ts';
import { StatusChipWithTooltip } from '~/modules/covenants/components/StatusChipWithTooltip.tsx';
import type { TApplicationStatus } from '~/modules/covenants/types.ts';
import { getApplicationStatusChipSx } from '~/modules/covenants/tableUtils.ts';

interface IAppStatusChipProps {
  status: TApplicationStatus;
}

export const AppStatusChip: React.FC<IAppStatusChipProps> = ({ status }) => {
  const { label, color, description } = getAppStatusConfig(status);

  return (
    <StatusChipWithTooltip
      label={label}
      color={color}
      size="medium"
      description={description}
      chipSx={getApplicationStatusChipSx(status)}
    />
  );
};
